import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-circle-left",
  templateUrl: "./med-icon-arrow-circle-left.component.html",
})
export class MedIconArrowCircleLeftComponent extends SvgMixinComponent {}
